module.exports = __webpack_public_path__ + "img/BE0873296641.fd1d6f99.png";